import React, { useEffect, useState } from 'react';
import ReactTable from 'react-table-v6';
import '../../../../../styles/custom.css';
import { CustomNoDataComponent, makeFirstLetterCapital,convertDateToDifferentTZ } from '../../../../../utility/utility';
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import ReactTooltip from 'react-tooltip';
import * as actions from '../../../../../redux/actions/index';
import { useSelector, useDispatch } from 'react-redux';
import { ClapSpinner } from 'react-spinners-kit';
import 'react-table-v6/react-table.css';
import { routes } from '../../../../../utility/constants/constants';
import {  convertDateUTCFormAuditToSelectedTimezone } from '../../../../../utility/TimezoneOperations/timezoneUtility';
var moment = require('moment');

let DailyKittingTable = (props) => {

    const dispatch = useDispatch();
    // const SearchValue = useSelector(state => state.form.searchScheduledTask && state.form.searchScheduledTask.values ? state.form.searchScheduledTask.values : {});
    const DateGenerate = useSelector(state => state.InventoryModuleReducer.dataGenerated);
    // const values = useSelector(state => state.InventoryModuleReducer.scheduledTask_searchValues);
    const No_of_pages = useSelector(state => state.InventoryModuleReducer.dailyKitting_total_pages);
    const No_of_rows = useSelector(state => state.InventoryModuleReducer.dailyKitting_no_of_rows);
    const isdailyKitting = useSelector(state => state.InventoryModuleReducer.isdailyKitting);
    const dailyKittingCurPage = useSelector(state => state.InventoryModuleReducer.dailyKittingCurPage);
    const SearchOrResetScheduledTaskListClicked = useSelector(state => state.InventoryModuleReducer.SearchOrResetScheduledTaskListClicked);

    const accountTimezone = 'America/Los_Angeles';

    const data = props.dailyKitting_list && props.dailyKitting_list.map((value) => {
        
        return {
            date: value.date ?  convertDateUTCFormAuditToSelectedTimezone(value.date,value?.account?.timezone) : '-',
            count :  value && value.daily_kit_log_sections ? value.daily_kit_log_sections.count : '-',
            item : value && value?.daily_kit_log_sections?.inventory_product ? value.daily_kit_log_sections.inventory_product.name :"-",
            specialist :   value && value.daily_kit_log_sections ? value.daily_kit_log_sections.specialist : '-',
            location : value?.location ? value.location :"-",
            shift_time : value?.shift_time ? `${value.shift_time.split(":")[0]} Hour` :"-",
            job: value?.account_id && value?.account ? makeFirstLetterCapital(value.account.name) :"-",
            actions:
                <>
                <span className="mr_20 account_edit_icn" onClick={() => props.history.push(`/daily-kitting/view/${value.id}`)} ><i class="fas fa-eye" aria-hidden="true" ></i></span>
                {props.isCreateAccess ? <span className="mr_20 account_edit_icn"  onClick={() => props.history.push(`/daily-kitting/${value.id}`)} ><i class="fa fa-pencil" aria-hidden="true" ></i></span> : null}
                </>
        }
    })

    const columns = [
        {
            Header: <><span> Job </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'job',
            show: props.dailyKitting_list.length !== 0,
            //width: 235,
        },
        {
            Header: <><span> Location </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'location',
            show: props.dailyKitting_list.length !== 0,
            //width: 235,
        },
        {
            Header: <><span> Shift </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'shift_time',
            show: props.dailyKitting_list.length !== 0,
            //width: 135,
        },
        {
            Header: <><span> Date </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'date',
            show: props.dailyKitting_list.length !== 0,
            //width: 135,
        },
        {
            Header: <><span> Specialist</span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'specialist',
            show: props.dailyKitting_list.length !== 0,
            //width: 235,
        },
        {
            Header: <><span> Item </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'item',
            show: props.dailyKitting_list.length !== 0,
            //width: 235,
        },
        {
            Header: <><span> Count</span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'count',
            show: props.dailyKitting_list.length !== 0,
            // width : 200,
        },
        {
            Header: '',
            accessor: 'actions',
           // width: 135,
            sortable:false,
        }
    ]

    const [tablePage, setTablePage] = useState(0)
    const tablePageNew =  React.useRef()
    if(dailyKittingCurPage !== tablePageNew.current) {
        tablePageNew.current = dailyKittingCurPage;
      }
    const setTablePageFn = (page) => {
        setTablePage(page)
        props.scheduledTaskListPageClicked(page)
        tablePageNew.current = page;
    }

    const fetchData = (state, instance) => {
        if (SearchOrResetScheduledTaskListClicked) {
            dispatch(actions.resetSearchOrResetInventory())
        } else {
            if (!DateGenerate && !props.isdailyKitting) {
                state.page = 2;
                const limit = state.pageSize;
                let page = tablePageNew.current >= 0 ? tablePageNew.current + 1 : dailyKittingCurPage + 1;
                const inventoryItemsList_no_of_rows = state.pageSize;
                if(No_of_rows != inventoryItemsList_no_of_rows) {
                    page = 1;
                    setTablePageFn(0)
                }
                
                const order = state.sorted[0]?.id;
                const orderBy = state.sorted && state.sorted.length ? state.sorted[0]?.desc === true ? 'desc' : 'asc' : null;
                // const accountId = SearchValue.id ? SearchValue.id : null;
                // const taskName = SearchValue.name ? SearchValue.name : null;
                // const companyName = SearchValue.company ? SearchValue.company : null;
                // const accountName = SearchValue.job ? SearchValue.job : null;
                // const from = SearchValue.fromDate ? convertDateToDifferentTZ(SearchValue.fromDate, 'from') : null;
                // const to = SearchValue.toDate ? convertDateToDifferentTZ(SearchValue.toDate, 'to') : null;
                props.getAllDailyKitting({page,limit, order, orderBy})
            }
        }
    }

    return (
        SearchOrResetScheduledTaskListClicked && props.isdailyKitting ?
            <div  >
                <ClapSpinner backColor="#89073c" size={40} frontColor="#89073c8a" />
            </div>
            :
            <ReactTable
                data={data}
                loading={props.isdailyKitting}
                minRows={0}
                defaultPageSize={No_of_rows}
                pages={No_of_pages}
                gotoPage={dailyKittingCurPage}
                page = { dailyKittingCurPage }
                onPageChange={(page) => {setTablePageFn(page)}}
                // onPageSizeChange={props.onUserPageSizeChange}
                manual
                onFetchData={fetchData}
                showPaginationTop={true}
                showPaginationBottom={false}
                showPagination={props.dailyKitting_list.length !== 0}
                columns={columns}
                // style={{marginTop: '10px'}}
                NoDataComponent={() => CustomNoDataComponent(isdailyKitting, 'No Daily Kitting List Found')}
                LoadingComponent={() =>
                    isdailyKitting ?
                        <div style={{
                            display: "block",
                            position: "absolute",
                            left: 0,
                            height: '100%',
                            right: 0,
                            background: "rgba(255,255,255,0.8)",
                            transition: "all .3s ease",
                            top: 0,
                            bottom: 0,
                            textAlign: "center"
                        }}
                            className="loader_btn_block">
                            <ClapSpinner backColor="#89073c" size={40} frontColor="#89073c8a" />
                        </div> : null}
                getTheadThProps={(state, rowInfo, column, instance) => {
                    // console.log(column);
                    return {
                        style: {
                            borderTop: 'none',
                            borderBottom: 'none',
                            borderRight: 'none',
                            textAlign: 'center',
                            color: '#566975',
                            fontSize: '14px',
                            fontWeight: '600',
                            whiteSpace: 'nowrap',
                            float: 'left',
                        }
                    }
                }
                }
                getTrProps={(state, rowInfo, column, instance) => {
                    // onclick = () => userDetail(rowInfo ? rowInfo.row.user : rowInfo);
                    console.log(column);
                    return {
                        className: 'react-table-tr-element',
                        style: {
                            border: '1px solid #c7cdd1',
                            transition: '.3s ease-in-out',
                            width: '100%',
                            // borderRadius: '4px',
                            // height: '80px',
                            marginTop: '5px',
                            float: 'left'
                        }
                    }

                }}
                getTdProps={(state, rowInfo, column, instance) => {

                    if (column.id == 'image') {
                        return {
                            style: {
                                marginTop: '0px'
                            }
                        }
                    } else {
                        return {
                            className: 'react-td-element',
                        }
                        //  {
                        //   style: {
                        //     borderTop: 'none',
                        //     verticalAlign: 'middle',
                        //     fontSize: '14px',
                        //     color: '#2b3034',
                        //     marginTop: '10px !important',
                        //     textAlign: 'center',
                        //   }
                        // }
                    }
                }
                }
                // getPaginationProps={() => {
                //     return {
                //         style: {
                //             marginTop: '50px',
                //             border: 'none',
                //             boxShadow: 'none'
                //         }
                //     }
                // }
                // }
                getProps={() => {
                    return {
                        style: {
                            border: 'none'
                        }
                    }
                }}
            />
    )
}

export default DailyKittingTable;